// @flow
import React, { Component } from 'react';
import moment from 'moment';
import { includes, pull } from 'lodash/fp';
import getFeed from './graphql/get-feed';
import upvote from './graphql/upvote';
import {
  Wrapper,
  ContentWrapper,
  Title,
  Meta,
  Chevron,
  ChevronButton,
  Count,
  ErrorText,
} from './feed.styles';

type Props = {};

class FeedPage extends Component {
  state = {
    loadingUpvoteForIds: [],
  };

  handleUpVote = proposalId => async () => {
    this.setState({
      loadingUpvoteForIds: [...this.state.loadingUpvoteForIds, proposalId],
    });
    try {
      await this.props.upvote({
        variables: { id: proposalId },
      });
      window.mixpanel.track('Upvote', { proposalId });
    } catch (e) {
      window.alert('Something went wrong');
    } finally {
      this.setState({
        loadingUpvoteForIds: pull(proposalId, this.state.loadingUpvoteForIds),
      });
    }
  };

  props: Props;

  render() {
    return (
      <div>
        {this.props.feedError && <ErrorText>Something went wrong...</ErrorText>}
        {this.props.feed.map(proposal => (
          <Wrapper key={proposal.id}>
            <ContentWrapper to={`/proposal/${proposal.id}`}>
              <Title>{proposal.title}</Title>
              <Meta>
                Posted on {moment(proposal.createdAt).format('dddd, MMMM Do')}{' '}
                by {proposal.user.firstName} {proposal.user.lastName}
              </Meta>
            </ContentWrapper>
            <ChevronButton
              isUpvoted={proposal.isUpvoted}
              disabled={includes(proposal.id, this.state.loadingUpvoteForIds)}
              onClick={
                proposal.isUpvoted ? null : this.handleUpVote(proposal.id)
              }
            >
              <Chevron
                isUpvoted={proposal.isUpvoted}
                className={`fa ${
                  proposal.isUpvoted ? 'fa-check' : 'fa-sort-asc'
                }`}
              />
              <Count>{proposal.totalUpvotes}</Count>
            </ChevronButton>
          </Wrapper>
        ))}
      </div>
    );
  }
}

export default upvote(getFeed(FeedPage));



// WEBPACK FOOTER //
// ./src/pages/feed/index.js